import React, {useContext, useMemo, useState} from 'react';
import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUsers} from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import Badge from "../Badge.jsx";
import FilterDropdown, {FILTER_SELECT_STYLES} from "../FilterDropdown.jsx";
import {FilterContext} from "./DashboardFilterContextProvider.jsx";

export default function OrderCustomerWholesaleFilter() {
    const {t} = useTranslation();
    const {customerClassificationAvailable, customerWholesale, setCustomerWholesale} = useContext(FilterContext) ?? {};
    const [selectOpened, setSelectOpened] = useState(false);

    const options = useMemo(() => [
        {value: null, label: t('filter.customer-wholesale.all')},
        {value: 'wholesale', label: t('filter.customer-wholesale.wholesale')},
        {value: 'non_wholesale', label: t('filter.customer-wholesale.non-wholesale')},
        {value: 'unknown', label: t('filter.customer-wholesale.unknown')},
    ], [t]);
    const selectedOption = options.find((option) => option.value === customerWholesale) ?? options[0];

    if (!customerClassificationAvailable) {
        return null;
    }

    return <FilterDropdown
        title={t('filter.customer-wholesale.title')}
        align="right"
        inhibitClosing={selectOpened}
        button={<div className="flex items-center justify-center gap-2 text-nowrap" title={t('filter.customer-wholesale.help')}>
            <FontAwesomeIcon icon={faUsers}/>
            {t('filter.customer-wholesale.title')}
            {customerWholesale && <Badge>{selectedOption.label}</Badge>}
        </div>}
    >
        <div className="w-80 p-2">
            <p className="mb-2 text-sm text-slate-600 dark:text-slate-300">{t('filter.customer-wholesale.help')}</p>
            <Select
                options={options}
                value={selectedOption}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={FILTER_SELECT_STYLES}
                onMenuOpen={() => setSelectOpened(true)}
                onMenuClose={() => setTimeout(() => setSelectOpened(false), 100)}
                onChange={(option) => setCustomerWholesale(option?.value ?? null)}
                className="datixo_select_container w-full"
                classNamePrefix="datixo_select"
                aria-label={t('filter.customer-wholesale.title')}
            />
        </div>
    </FilterDropdown>;
}
